import React from 'react'
import { Button } from '@astryxdesign/core/Button'

type ButtonProps = React.ComponentProps<typeof Button>

/**
 * The astryx Button with fully rounded ends. Used for the compact action row under a story
 * block (Copy, Edit/View, Insert/Replace) so the row reads as a set of pills rather than
 * boxes. Everything else — variants, icons, tooltips, disabled and loading states — is the
 * plain Button.
 */
export default function PillButton({ className, ...props }: ButtonProps): React.JSX.Element {
  return <Button {...props} className={className ? `pill-button ${className}` : 'pill-button'} />
}
